const ErrorMessage = ({ errorMessage }) => {
  return <div className="my-4 p-2 error-msg">{errorMessage}</div>;
};

export default ErrorMessage;
